import { useId, useState } from 'react';
import { useObjectUrls } from '../../../../../hooks/useObjectUrls';
import { clampIndex } from './carouselIndex';
import type { ScanImageTabId } from './scanImageTabs';
import { tallyCount } from './scanTally';
import type { ScanImage } from './scanZip';
import type { ScanImageSet, ScanImageSets } from './useScanImageSets';

const NO_IMAGES: readonly ScanImage[] = [];

export interface ScanGalleryState {
    baseId: string;
    segment: ScanImageTabId;
    set: ScanImageSet;
    urls: readonly string[];
    index: number;
    count: number;
    counts: Readonly<Record<ScanImageTabId, number | null>>;
    selectSegment: (segment: ScanImageTabId) => void;
    setIndex: (index: number) => void;
}

// Held above the gallery card, so the inline and full-screen copies show the same segment and image.
export function useScanGallery(sets: ScanImageSets): ScanGalleryState {
    const baseId = useId().replace(/:/g, '');
    const [segment, setSegment] = useState<ScanImageTabId>('model-views');
    const [index, setIndex] = useState(0);
    const set = sets[segment];
    const images = set.view.status === 'ready' ? set.view.images : NO_IMAGES;
    const urls = useObjectUrls(images);

    const selectSegment = (next: ScanImageTabId) => {
        setSegment(next);
        setIndex(0);
    };

    return {
        baseId,
        segment,
        set,
        urls,
        index: clampIndex(index, images.length),
        count: images.length,
        counts: {
            'model-views': tallyCount(sets['model-views'].tally),
            'screen-captures': tallyCount(sets['screen-captures'].tally)
        },
        selectSegment,
        setIndex
    };
}
